import { APP_GRID_HEADERS } from './APP_REPORT_CONFIG';
import { DOMAIN_GRID_HEADERS } from './DOMAIN_REPORT_CONFIG';
import { DOMAIN_TOP_LEVEL_CATEGORIES } from './TABBED_FILTERS_CONFIG';
import {
  APP_TOP_LEVEL_CATEGORIES,
  AppTopLevelCategory
} from './APP_TABBED_FILTERS_CONFIG';
import { CTV_TOP_LEVEL_CATEGORIES } from './CTV_TABBED_FILTERS_CONFIG';
import { CTV_GRID_HEADERS } from './CTV_REPORT_CONFIG';
import { CTV_IMPORT_OPTIONS } from './CTV_IMPORT_OPTIONS';
import { APPS_IMPORT_OPTIONS } from './APP_IMPORT_OPTIONS';
import { DOMAINS_IMPORT_OPTIONS } from './DOMAINS_IMPORT_OPTIONS';

export interface SideNavItem {
  key: string;
  title: string;
  icon: string;
  active: boolean;
}

export interface DashboardViewRiskBar {
  label: string;
  key: string;
}

export interface DashboardViewPieChartItem {
  value: number;
  rating: string;
  label: string;
}

export interface DashboardViewPieChartConfig {
  items: Array<DashboardViewPieChartItem>;
}

export interface DashboardViewSection1 {
  label: string;
  pieChartConfig: DashboardViewPieChartConfig;
  riskBars: Array<DashboardViewRiskBar>;
}

export interface DashboardViewSection3 {
  progressCircle1: DashboardViewPieChartItem;
}

export interface DashboardViewSection4 {
  progressCircle1?: DashboardViewPieChartItem;
  progressCircle2?: DashboardViewPieChartItem;
  progressCircle3?: DashboardViewPieChartItem;
  progressCircle4?: DashboardViewPieChartItem;
  progressCircle5?: DashboardViewPieChartItem;
  progressCircle6?: DashboardViewPieChartItem;
}

export interface DashboardViewConfig {
  section1?: DashboardViewSection1;
  section3?: DashboardViewSection3;
  section4?: DashboardViewSection4;
}

export interface ReportConfig {
  key: string;
  title: string;
  viewDetailsText: string;
  permission?: string;
  mainFilterItems: Array<MainFilterItem>;
  gridHeaders: Array<GridHeader>;
  dashboardViewConfig?: DashboardViewConfig;
  topLevelCategories: Array<AppTopLevelCategory>;
  disabled?: boolean;
  importParams?: Array<any>;
}

export interface FilterOption {
  value: string;
  apiValue: string;
  label: string;
  selected: boolean;
  hidden?: boolean;
  ignore?: boolean;
}

export interface MainFilterItem {
  key: string;
  label: string;
  type: string;
  selected: FilterOption;
  options: Array<FilterOption>;
  apiKey: string;
  hidden?: boolean;
  ignore?: boolean;
  position?: 'query' | 'path';
}

export interface GridHeader {
  label: string;
  key: string;
  sort: string;
  sortColumnKey?: string;
  hoverKey: string;
  format: string;
  template: string;
  hidden: boolean;
  lockedInFreemium?: boolean;
  tooltip?: string;
  permission?: string;
}

export interface CsvImportFilter {
  key: string;
  label: string;
  type: string;
  options: Array<CsvImportFilterOption>;
}

export interface CsvImportFilterOption {
  label: string;
  value: string;
}

export const APP_MAIN_FILTERS: Array<MainFilterItem> = [
  {
    key: 'param1',
    apiKey: 'appStore',
    label: 'Store',
    type: 'toggle',
    selected: {
      value: 'android',
      apiValue: 'android',
      label:
        '<img class="white mr-2" src="/assets/images/play-store-white.png" alt="Logo"/> <img class="black mr-2" src="/assets/images/play-store-black.png" alt="Play Store Icon"> Google Play',
      selected: false
    },
    options: [
      {
        value: 'all',
        apiValue: '',
        label: '',
        selected: false,
        hidden: true
      },
      {
        value: 'android',
        apiValue: 'android',
        label:
          '<img class="white mr-2" src="/assets/images/play-store-white.png" alt="Logo"/> <img class="black mr-2" src="/assets/images/play-store-black.png" alt="Play Store Icon"/> Google Play',
        selected: true
      },
      {
        value: 'ios',
        apiValue: 'ios',
        label: '<i class="fa fa-apple mr-2"></i>App Store',
        selected: false
      }
    ]
  },
  {
    key: 'param2',
    apiKey: 'device',
    label: 'Device',
    type: 'dropdown',
    selected: {
      value: 'GLOBAL',
      apiValue: 'GLOBAL',
      label: 'All Devices',
      selected: true
    },
    options: [
      {
        value: 'GLOBAL',
        apiValue: 'GLOBAL',
        label: 'All Devices',
        selected: true
      },
      {
        value: 'smartphone',
        apiValue: 'smartphone',
        label: 'Smartphone',
        selected: false
      },
      {
        value: 'tablet',
        apiValue: 'tablet',
        label: 'Tablet',
        selected: false
      }
    ]
  },
  {
    key: 'param3',
    apiKey: 'region',
    label: 'Region',
    type: 'dropdown',
    selected: {
      value: 'GLOBAL',
      apiValue: 'GLOBAL',
      label: 'GLOBAL',
      selected: true
    },
    options: [
      { value: 'NA', apiValue: 'NA', label: 'North America', selected: false },
      { value: 'EMEA', apiValue: 'EMEA', label: 'EMEA', selected: false },
      { value: 'LATAM', apiValue: 'LATAM', label: 'LATAM', selected: false },
      { value: 'APAC', apiValue: 'APAC', label: 'APAC', selected: false },
      { value: 'GLOBAL', apiValue: 'GLOBAL', label: 'GLOBAL', selected: true }
    ]
  }
];

export const CTV_MAIN_FILTERS: Array<MainFilterItem> = [
  {
    key: 'param1',
    apiKey: 'device',
    label: 'Device',
    type: 'toggle',
    hidden: false,
    selected: {
      value: 'roku',
      apiValue: 'roku',
      label: '<img src="/assets/images/roku.png" alt="Roku Icon"> Roku',
      selected: true
    },
    options: [
      {
        value: 'all',
        apiValue: '',
        label: '',
        selected: false,
        hidden: true
      },
      {
        value: 'roku',
        apiValue: 'roku',
        label: '<img src="/assets/images/roku.png" alt="Roku Icon"> Roku',
        selected: true
      },
      {
        value: 'firetv',
        apiValue: 'firetv',
        label:
          '<img src="/assets/images/firetv.png" alt="Fire TV Icon"> Fire TV',
        selected: false
      },
      {
        value: 'samsung',
        apiValue: 'samsung',
        label:
          '<img src="/assets/images/samsung.png" alt="Samsung Icon"> Samsung',
        selected: false
      },
      {
        value: 'tvos',
        apiValue: 'tvos',
        label: '<img src="/assets/images/tvos.png" alt="tvOS Icon"> tvOS',
        selected: false
      }
    ]
  },
  {
    key: 'param2',
    apiKey: 'region',
    label: 'Region',
    type: 'dropdown',
    selected: {
      value: 'GLOBAL',
      apiValue: 'GLOBAL',
      label: 'GLOBAL',
      selected: true
    },
    options: [
      { value: 'NA', apiValue: 'NA', label: 'North America', selected: false },
      { value: 'GLOBAL', apiValue: 'GLOBAL', label: 'GLOBAL', selected: true },
      { value: 'EMEA', apiValue: 'EMEA', label: 'EMEA', selected: false },
      { value: 'APAC', apiValue: 'APAC', label: 'APAC', selected: false },
      { value: 'LATAM', apiValue: 'LATAM', label: 'LATAM', selected: false }
    ]
  },
  {
    key: 'param3',
    apiKey: 'brand',
    label: 'Brand',
    hidden: true,
    ignore: true,
    type: 'dropdown',
    selected: {
      value: 'GLOBAL',
      apiValue: 'GLOBAL',
      label: 'GLOBAL',
      selected: true
    },
    options: [
      { value: 'GLOBAL', apiValue: 'GLOBAL', label: 'GLOBAL', selected: true }
    ]
  },
  {
    key: 'param4',
    apiKey: 'includeSpoofing',
    label: 'Include Spoofing',
    type: 'slider-toggle',
    position: 'query',
    selected: { value: 'F', apiValue: 'F', label: 'Exclude', selected: true },
    options: [
      { value: 'F', apiValue: 'F', label: 'Exclude', selected: true },
      { value: 'T', apiValue: 'T', label: 'Include', selected: false }
    ]
  }
];

export const DOMAIN_MAIN_FILTERS: Array<MainFilterItem> = [
  {
    key: 'param1',
    apiKey: 'device',
    label: 'Device',
    type: 'dropdown',
    selected: {
      value: 'GLOBAL',
      apiValue: 'GLOBAL',
      label: 'All Devices',
      selected: true
    },
    options: [
      {
        value: 'GLOBAL',
        apiValue: 'GLOBAL',
        label: 'All Devices',
        selected: true
      },
      {
        value: 'desktop',
        apiValue: 'desktop',
        label: 'Desktop',
        selected: false
      },
      {
        value: 'mobile',
        apiValue: 'mobile',
        label: 'Mobile',
        selected: false
      }
    ]
  },
  // {
  //   key: 'param2',
  //   apiKey: 'region',
  //   label: 'Region',
  //   type: 'dropdown',
  //   selected: {
  //     value: 'GLOBAL',
  //     apiValue: 'GLOBAL',
  //     label: 'GLOBAL',
  //     selected: true
  //   },
  //   options: [
  //     { value: 'US', apiValue: 'US', label: 'US', selected: false },
  //     {
  //       value: 'NONUS',
  //       apiValue: 'NON-US',
  //       label: 'Non U.S.',
  //       selected: false
  //     },
  //     { value: 'GLOBAL', apiValue: 'GLOBAL', label: 'GLOBAL', selected: true }
  //   ]
  // },
  {
    key: 'param2',
    apiKey: 'region',
    label: 'Region',
    type: 'dropdown',
    selected: {
      value: 'GLOBAL',
      apiValue: 'GLOBAL',
      label: 'GLOBAL',
      selected: true
    },
    options: [
      { value: 'GLOBAL', apiValue: 'GLOBAL', label: 'GLOBAL', selected: true },
      { value: 'APAC', apiValue: 'APAC', label: 'APAC', selected: false },
      { value: 'EMEA', apiValue: 'EMEA', label: 'EMEA', selected: false },
      { value: 'LATAM', apiValue: 'LATAM', label: 'LATAM', selected: false },
      { value: 'NA', apiValue: 'NA', label: 'North America', selected: false }
    ]
  },
  {
    key: 'param3',
    apiKey: 'isSubDomain',
    label: 'Include Subdomains',
    type: 'slider-toggle',
    selected: { value: 'F', apiValue: 'F', label: 'Exclude', selected: true },
    options: [
      { value: 'F', apiValue: 'F', label: 'Exclude', selected: true },
      { value: 'T', apiValue: 'T', label: 'Include', selected: false }
    ]
  }
];

export const DEFAULT_TREND_FILTERS: Array<MainFilterItem> = [
  {
    key: 'interval',
    apiKey: 'timeInterval',
    label: 'Time Interval',
    type: 'dropdown',
    selected: {
      value: 'last7',
      apiValue: 'last7',
      label: 'Last 7 Days',
      selected: true
    },
    options: [
      {
        value: 'last7',
        apiValue: 'last7',
        label: 'Last 7 Days',
        selected: true
      },
      {
        value: 'last30',
        apiValue: 'last30',
        label: 'Last 30 Days',
        selected: false
      }
    ]
  },
  {
    key: 'category',
    apiKey: 'category',
    label: 'Category',
    type: 'dropdown',
    selected: {
      value: 'GLOBAL',
      apiValue: 'GLOBAL',
      label: 'All Categories',
      selected: true
    },
    options: [
      {
        value: 'GLOBAL',
        apiValue: 'GLOBAL',
        label: 'All Categories',
        selected: true
      }
    ]
  },
  {
    key: 'inventory',
    apiKey: 'inventoryType',
    label: 'Inventory Type',
    type: 'dropdown',
    selected: {
      value: 'all',
      apiValue: '',
      label: 'Video/Display',
      selected: true
    },
    options: [
      {
        value: 'all',
        apiValue: '',
        label: 'Video/Display',
        selected: true
      },
      {
        value: 'video',
        apiValue: 'video',
        label: 'Video',
        selected: false
      },
      {
        value: 'display',
        apiValue: 'display',
        label: 'Display',
        selected: false
      }
    ]
  },
  {
    key: 'ivt',
    apiKey: 'isExcludeIvt',
    label: 'Is Exclude IVT',
    type: 'toggle',
    selected: {
      value: 'F',
      apiValue: 'F',
      label: 'Include IVT',
      selected: true
    },
    options: [
      {
        value: 'F',
        apiValue: 'F',
        label: 'Include IVT',
        selected: true
      },
      {
        value: 'T',
        apiValue: 'F',
        label: 'Exclude IVT',
        selected: false
      }
    ]
  },
  {
    key: 'pricing',
    apiKey: 'pricingType',
    label: 'Pricing Type',
    type: 'toggle',
    selected: {
      value: 'free',
      apiValue: 'free',
      label: 'Free',
      selected: true
    },
    options: [
      {
        value: 'free',
        apiValue: 'free',
        label: 'Free',
        selected: true
      },
      {
        value: 'paid',
        apiValue: 'paid',
        label: 'Paid',
        selected: false
      },
      {
        value: 'grossing',
        apiValue: 'grossing',
        label: 'Grossing',
        selected: false
      }
    ]
  }
];

export const APP_DASHBOARD_VIEW_CONFIG: DashboardViewConfig = {
  section1: {
    label: 'Risk',
    pieChartConfig: {
      items: []
    },
    riskBars: []
  },
  section3: {
    progressCircle1: {
      value: 0.5,
      rating: 'low',
      label: 'Med & High Risk'
    }
  },
  section4: {
    progressCircle1: {
      value: 0.5,
      rating: 'low',
      label: 'Med & High Risk'
    },
    progressCircle2: {
      value: 0.5,
      rating: 'low',
      label: 'Med & High Risk'
    },
    progressCircle3: {
      value: 0.5,
      rating: 'low',
      label: 'Med & High Risk'
    },
    progressCircle4: {
      value: 0.5,
      rating: 'low',
      label: 'Med & High Risk'
    },
    progressCircle5: {
      value: 0.5,
      rating: 'low',
      label: 'Med & High Risk'
    },
    progressCircle6: {
      value: 0.5,
      rating: 'low',
      label: 'Med & High Risk'
    }
  }
};

export const DOMAIN_DASHBOARD_VIEW_CONFIG: DashboardViewConfig = {
  section1: {
    label: 'Risk',
    pieChartConfig: {
      items: []
    },
    riskBars: []
  },
  section3: {
    progressCircle1: {
      value: 0.5,
      rating: 'medhigh',
      label: 'Med & High Risk'
    }
  }
};

export const REPORT_CONFIG: Array<ReportConfig> = [
  {
    key: 'ctv',
    title: 'Connected TV',
    permission: 'mrtOTTDiscovery',
    viewDetailsText: 'View App Details',
    mainFilterItems: CTV_MAIN_FILTERS,
    gridHeaders: CTV_GRID_HEADERS,
    dashboardViewConfig: APP_DASHBOARD_VIEW_CONFIG,
    topLevelCategories: CTV_TOP_LEVEL_CATEGORIES,
    importParams: CTV_IMPORT_OPTIONS
  },
  {
    key: 'apps',
    title: 'Mobile',
    permission: 'mrtAppDiscovery',
    viewDetailsText: 'View App Details',
    mainFilterItems: APP_MAIN_FILTERS,
    gridHeaders: APP_GRID_HEADERS,
    dashboardViewConfig: APP_DASHBOARD_VIEW_CONFIG,
    topLevelCategories: APP_TOP_LEVEL_CATEGORIES,
    importParams: APPS_IMPORT_OPTIONS
  },
  {
    key: 'domains',
    title: 'Domains',
    permission: 'mrtSearch',
    viewDetailsText: 'View Domain Details',
    mainFilterItems: DOMAIN_MAIN_FILTERS,
    gridHeaders: DOMAIN_GRID_HEADERS,
    dashboardViewConfig: DOMAIN_DASHBOARD_VIEW_CONFIG,
    topLevelCategories: DOMAIN_TOP_LEVEL_CATEGORIES,
    importParams: DOMAINS_IMPORT_OPTIONS
  }
];
